import { Button, Flex, Link, ModuleLayout, Space, Spacing, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { Scope } from '../../enums/scope'
import { isAuthorized } from '../../utils/isAuthorized'
import { getOrganizationViewUrl } from '../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../utils/routing/reactRoute'
import { useVisibleExportsCards } from './hooks/useVisibleExportsCards'
import * as Styled from './styles'
import { isProductionLikeUrl } from './utils/isProductionLikeUrl'

const FRENCH_CERTIFICATE_URL = `https://assets.${isProductionLikeUrl() ? '' : 'staging.'}billy.dk/assets/Attestation_CGI_ShineDK.pdf`

export const Exports = () => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { visibleCards } = useVisibleExportsCards()

  const profitAndLossUrl = getOrganizationViewUrl(
    organization?.url,
    reactRoute.organization.reports.getProfitAndLossRoute(),
  )
  const balanceSheetUrl = getOrganizationViewUrl(
    organization?.url,
    reactRoute.organization.reports.getBalanceSheetRoute(),
  )
  const trialBalanceUrl = getOrganizationViewUrl(
    organization?.url,
    reactRoute.organization.reports.getTrialBalanceRoute(),
  )

  const isReportsReadAuthorized = isAuthorized(Scope.ReportsRead)
  const isFrenchOrganization = organization?.countryId === 'FR'
  const isDutchOrganization = organization?.countryId === 'NL'
  const isGermanOrganization = organization?.countryId === 'DE'
  const showShortcuts = !isDutchOrganization && !isGermanOrganization && isReportsReadAuthorized

  const handleClickCertificate = useCallback(() => {
    window.open(FRENCH_CERTIFICATE_URL, '_blank')
  }, [])

  return (
    <ModuleLayout
      title={t('exports')}
      sideActions={
        isFrenchOrganization ? (
          <Button variant="outlined" onClick={handleClickCertificate}>
            {t('exports.certificate')}
          </Button>
        ) : null
      }
    >
      {showShortcuts && (
        <>
          <Flex alignItems="center" justifyContent="space-between">
            <Text variant="h2">{t('exports.shortcuts')}</Text>
            <Flex gap={Spacing.S16}>
              <Link to={profitAndLossUrl}>{t('exports.shortcuts.link.profit_and_loss_statement')}</Link>
              <Link to={balanceSheetUrl}>{t('exports.shortcuts.link.balance_sheet')}</Link>
              <Link to={trialBalanceUrl}>{t('exports.shortcuts.link.trial_balance')}</Link>
            </Flex>
          </Flex>
          <Space size="s24" />
        </>
      )}

      <Styled.ExportsCards>
        {visibleCards.map((card) => {
          const CardComponent = card.component

          return <CardComponent key={card.id} />
        })}
      </Styled.ExportsCards>
    </ModuleLayout>
  )
}
